module.exports = __webpack_public_path__ + "static/media/ao.8b6f2ec2.svg";